module.exports = "/lmstools/fonts/vendor/@mdi/materialdesignicons-webfont.woff?20b6ebf31bfa23d12cfa6cfd71acf331";